/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, Image, Tag } from "antd";
import { formatEstimatedHrs } from "../../../../config/utils";

function SimpleTaskCard(props: any) {
  const {
    crewYardName,
    isLastIndex,
    selectedDate,
    isFirstIndex,
    durationMinutes,
  } = props;

  const isToday = selectedDate
    ? new Date(selectedDate).toDateString() === new Date().toDateString()
    : false;

  return (
    <div className="role_wrapper">
      {(isFirstIndex || isLastIndex) && (
        <Card className={isToday ? "crewListCard scheduled" : `crewListCard`}>
          <div className="taskTitle">
            {isFirstIndex && (
              <Image src="/images/schedule/icon-home.svg" preview={false} />
            )}
            {isLastIndex && (
              <Image
                src="/images/schedule/icon-crew-yard.svg"
                preview={false}
              />
            )}{" "}
            <span>
              {crewYardName?.length > 0 ? crewYardName : "No crew yard"}
            </span>
          </div>
          {crewYardName?.length > 0 && (
            <Tag>
              <Image
                src="/images/schedule/clock-icon.svg"
                preview={false}
                style={{ width: "14px" }}
              />
              {formatEstimatedHrs(durationMinutes / 60)}
            </Tag>
          )}
        </Card>
      )}
    </div>
  );
}

export default SimpleTaskCard;
